import {DropdownContainer} from "./DropdownContainer";
import {SelectBody} from "./SelectBody";

export class MultiSelector {
    private container: DropdownContainer | null = null
    private body: SelectBody | null = null
    private readonly onChange: () => void;
    private readonly initialSelectedValues: string[] = [];

    public constructor(dropdownHtml: HTMLElement, onChange: () => void = () => {}) {
        this.onChange = onChange;

        if (dropdownHtml) {
            this.container = new DropdownContainer(dropdownHtml, this.getOnClearButtonClick());
            this.body = new SelectBody(
                dropdownHtml.querySelector(".js-wl-checkbox-multi-select") as HTMLElement,
                true,
                true,
                this.valueChanged.bind(this)
            );
            this.initialSelectedValues = this.actualSelectedValues()
            this.manageComponents(this.initialSelectedValues, null);
        }
    }

    private getOnClearButtonClick() {
        return () => {
            this.body?.deselectAll()
            this.valueChanged([], [], null);
        };
    }

    private valueChanged(selectedValuesText: string[], selectedValues: string[], input: HTMLInputElement | null) {
        this.manageComponents(selectedValues, input);
        this.onChange();
    }

    private manageComponents(selectedValues: string[], input: HTMLInputElement | null) {
        this.checkNeededCheckbox(selectedValues, input);
        this.informLabel();
        this.manageApplyButton();
        this.manageClearButton();
    }

    private checkNeededCheckbox(selectedValues: string[], input: HTMLInputElement | null) {
        if (input && selectedValues.length == 1 && selectedValues[0] == input.value) {
            let valuesToCheck = [0]
            for(let i = parseInt(input.value)+1; i < 6; i++) {
                valuesToCheck.push(i);
            }

            this.body!!.checkValues(valuesToCheck);
        }
    }

    private informLabel() {
        const values = this.body!.selectedValuesText()
        if (values.length == 0) {
            this.container!!.updateToDefaultLabel()
        } else {
            this.container!!.updateLabel(values.join(","))
        }
    }

    private actualSelectedValues() {
        return this.body ? this.body.selectedValues() : [];
    }

    private manageApplyButton() {
        if (JSON.stringify(this.initialSelectedValues) == JSON.stringify(this.actualSelectedValues())) {
            this.container?.disableApplyButton()
        } else {
            this.container?.enableApplyButton()
        }
    }

    private manageClearButton() {
        if (this.actualSelectedValues().length == 0) {
            this.container?.disableClearButton()
        } else {
            this.container?.enableClearButton()
        }
    }
}